module.exports = __webpack_public_path__ + "img/tarj2-10.169d061b.svg";